var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "yd-table",
        {
          attrs: {
            settings: false,
            data: _vm.logList,
            border: true,
            loading: _vm.loading,
            "max-height": "400px",
            size: "small",
            "tooltip-effect": "dark",
          },
          on: { onChange: _vm.onTableChange },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "recordTime", label: "操作时间", width: "150" },
          }),
          _c("el-table-column", {
            attrs: { prop: "operator", label: "操作方", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.operator || "-") +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "operatorName", label: "操作人", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.operatorUserIdType === 2
                      ? _c("yd-link", {
                          attrs: {
                            value:
                              scope.row.operatorName ||
                              scope.row.operateUserName,
                            type: "systemUser",
                            query: { userId: scope.row.unionUserId },
                          },
                        })
                      : scope.row.operatorUserIdType === 1
                      ? _c("yd-link", {
                          attrs: {
                            permi: "user_center_manage",
                            value:
                              scope.row.operatorName ||
                              scope.row.operateUserName,
                            url:
                              "/customer/user/index/" +
                              (scope.row.operatorName ||
                                scope.row.operateUserName) +
                              "/" +
                              scope.row.unionUserId,
                            type: "userInfo",
                            need: true,
                          },
                        })
                      : _c("span", [
                          _vm._v(
                            _vm._s(
                              scope.row.operatorName ||
                                scope.row.operateUserName
                            )
                          ),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "operateTypeMsg", label: "操作类型", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          scope.row.operateTypeMsg || scope.row.operateType
                        ) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "newRecord", label: "操作内容" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.operateType == 20005
                      ? _vm._l(
                          (scope.row.newRecord || "").split(","),
                          function (item, index) {
                            return _c(
                              "div",
                              {
                                key: item + "_" + index,
                                staticClass: "image-view",
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-zoom-in icon",
                                }),
                                _c("el-image", {
                                  attrs: {
                                    src: item,
                                    "preview-src-list": (
                                      scope.row.newRecord || ""
                                    ).split(","),
                                  },
                                }),
                              ],
                              1
                            )
                          }
                        )
                      : [
                          _vm.type === 2 && _vm.status === "已改签"
                            ? _c("span", {
                                staticStyle: { "white-space": "pre-wrap" },
                                domProps: {
                                  innerHTML: _vm._s(
                                    scope.row.newRecord
                                      ? "生成新订单：" + scope.row.newRecord
                                      : "无"
                                  ),
                                },
                              })
                            : _c("span", {
                                staticStyle: { "white-space": "pre-wrap" },
                                domProps: {
                                  innerHTML: _vm._s(
                                    scope.row.newRecord || "无"
                                  ),
                                },
                              }),
                        ],
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "oldRecord", label: "原内容" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm.type === 2 && _vm.status === "已改签"
                      ? _c("span", {
                          staticStyle: { "white-space": "pre-wrap" },
                          domProps: {
                            innerHTML: _vm._s(
                              scope.row.oldRecord
                                ? "原订单：" + scope.row.oldRecord
                                : "无"
                            ),
                          },
                        })
                      : _c("span", {
                          staticStyle: { "white-space": "pre-wrap" },
                          domProps: {
                            innerHTML: _vm._s(scope.row.oldRecord || "无"),
                          },
                        }),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }